module.exports = __webpack_public_path__ + "img/modal-rejected-icon.46f5d4d8.svg";